// cleancode-ui/src/components/TrialStatus.jsx
import React, { useState, useEffect } from 'react';
import { useEnvironment } from '../contexts/EnvironmentContext';
import './Login.css';

const TrialStatus = () => {
  const { apiBaseUrl } = useEnvironment();
  const [trialInfo, setTrialInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTrialStatus();
  }, []);

  const fetchTrialStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${apiBaseUrl}/billing/trial-status`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch trial status');
      }

      const data = await response.json();
      setTrialInfo(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="trial-status">
        <div className="trial-loading">Loading trial information...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="trial-status">
        <div className="trial-error">Error loading trial status: {error}</div>
      </div>
    );
  }

  if (!trialInfo) {
    return null;
  }

  // Don't show anything if user is not subscribed and has no trial
  if (!trialInfo.is_subscribed && !trialInfo.has_trial) {
    return null;
  }

  const getStatusMessage = () => {
    console.log('TrialStatus data:', trialInfo); // Debug log
    if (trialInfo.has_trial) {
      if (trialInfo.trial_days_remaining > 0) {
        return {
          type: 'trial',
          message: `You have ${trialInfo.trial_days_remaining} days left in your free trial`,
          color: '#6fd0e7' // Use direct color instead of CSS variable
        };
      } else {
        return {
          type: 'trial-expired',
          message: 'Your free trial has ended',
          color: '#ef4444' // Use direct color instead of CSS variable
        };
      }
    } else if (trialInfo.is_subscribed) {
      return {
        type: 'subscribed',
        message: `You're subscribed to ${trialInfo.current_plan || 'CleanCode.ai'}`,
        color: '#10b981' // Use direct color instead of CSS variable
      };
    }
    return null;
  };

  const status = getStatusMessage();
  console.log('TrialStatus status:', status); // Debug log
  if (!status) return null;

  return (
    <div className="trial-status">
      <div 
        className="trial-banner"
        style={{ backgroundColor: `${status.color}15`, borderColor: status.color }}
      >
        <div className="trial-content">
          <span className="trial-icon">
            {status.type === 'trial' && '⏰'}
            {status.type === 'trial-expired' && '⚠️'}
            {status.type === 'subscribed' && '✅'}
          </span>
          <span className="trial-message" style={{ color: '#ffffff', fontSize: '14px' }}>{status.message}</span>
          {status.type === 'trial' && trialInfo.trial_days_remaining <= 3 && (
            <button 
              className="trial-action"
              onClick={() => window.location.href = '/billing'}
            >
              Manage Subscription
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrialStatus;
